import React from 'react';
import FormRegis from '../card/formRegis';

const Regis = () => {
    return (
        <div>
            <h5>Create Account</h5>
            <p>Let's get Job elit. Quo amet quia rem id aliquam rerum, obcaecati est eos s</p>
            <FormRegis/>
        </div>
    );
}

export default Regis;
